/* tslint:disable */
/* eslint-disable */

/**
 * Ein Teilnehmer einer Pr�fung (exam_details)
 * @export
 * @interface ExamParticipantDto
 */
export interface ExamParticipantDto {
  /** Startnummer */
  startNo?: number | null;
  /** Reihenfolge innerhalb der Pr�fung (Startfolge) */
  startingOrder?: number | null;
  /** Platzierung */
  place?: number | null;
  /** Pferdename */
  horseName?: string | null;
  /** Register-ID des Pferdes */
  horseRegisterId?: string | null;
  /** Rasse (Volltext f�r Mouseover) */
  horseBreed?: string | null;
  /** Rasse-Kurzzeichen */
  horseBreedKz?: string | null;
  /** Z�chter */
  horseBreeder?: string | null;
  /** Besitzer */
  horseOwner?: string | null;
  /** Vorname Reiter */
  riderFirstName?: string | null;
  /** Nachname Reiter */
  riderLastName?: string | null;
  /** Register-ID des Reiters */
  riderRegisterId?: string | null;
  /** Gesamtergebnis */
  result?: string | null;
  /** Einzelwertnoten w1, w2, ... */
  scores?: number[] | null;
}

export function instanceOfExamParticipantDto(value: object): value is ExamParticipantDto {
  return true;
}

export function ExamParticipantDtoFromJSON(json: any): ExamParticipantDto {
  return ExamParticipantDtoFromJSONTyped(json, false);
}

export function ExamParticipantDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExamParticipantDto {
  if (json == null) return json;
  return {
    startNo: json['startNo'] == null ? undefined : json['startNo'],
    startingOrder: json['startingOrder'] == null ? undefined : json['startingOrder'],
    place: json['place'] == null ? undefined : json['place'],
    horseName: json['horseName'] == null ? undefined : json['horseName'],
    horseRegisterId: json['horseRegisterId'] == null ? undefined : json['horseRegisterId'],
    horseBreed: json['horseBreed'] == null ? undefined : json['horseBreed'],
    horseBreedKz: json['horseBreedKz'] == null ? undefined : json['horseBreedKz'],
    horseBreeder: json['horseBreeder'] == null ? undefined : json['horseBreeder'],
    horseOwner: json['horseOwner'] == null ? undefined : json['horseOwner'],
    riderFirstName: json['riderFirstName'] == null ? undefined : json['riderFirstName'],
    riderLastName: json['riderLastName'] == null ? undefined : json['riderLastName'],
    riderRegisterId: json['riderRegisterId'] == null ? undefined : json['riderRegisterId'],
    result: json['result'] == null ? undefined : json['result'],
    scores: json['scores'] == null ? undefined : json['scores'],
  };
}

export function ExamParticipantDtoToJSON(json: any): ExamParticipantDto {
  return ExamParticipantDtoToJSONTyped(json, false);
}

export function ExamParticipantDtoToJSONTyped(value?: ExamParticipantDto | null, ignoreDiscriminator: boolean = false): any {
  if (value == null) return value;
  return {
    startNo: value['startNo'],
    startingOrder: value['startingOrder'],
    place: value['place'],
    horseName: value['horseName'],
    horseRegisterId: value['horseRegisterId'],
    horseBreed: value['horseBreed'],
    horseBreedKz: value['horseBreedKz'],
    horseBreeder: value['horseBreeder'],
    horseOwner: value['horseOwner'],
    riderFirstName: value['riderFirstName'],
    riderLastName: value['riderLastName'],
    riderRegisterId: value['riderRegisterId'],
    result: value['result'],
    scores: value['scores'],
  };
}
